import styled from 'styled-components'

export const HoverCursor = styled.div `
&:hover {
  cursor: pointer;
}
`
export const ProfileBox = styled.div `
  width: 100%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 5px;
  background-color: white;
`

export const CompanyCardWrapper = styled.div `
height: 520px;
width: 100%;
box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
transition: all 0.3s cubic-bezier(.25,.8,.25,1);
margin-bottom: 15px;
padding: 30px;
border-radius: 5px;
background-color: white;
&:hover {
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
}
`
export const IconWrapper = styled.div `
height: 45px;
`

export const MemberProfileWrapper = styled.div `
  margin-left: 100px;
  @media (max-width: 990px) {
    margin-left: 0px;
  }
`

export const ProfileLabels = styled.p `
margin: 0px;
color: ${props => props.color};
@media (max-width: 500px) {
  text-align: center;
}
`
ProfileLabels.defaultProps = {
    color: "black"
}
export const CompanyIndustry = styled.p `
margin: 0px;
text-align: center;
color: ${props => props.color};
`
CompanyIndustry.defaultProps = {
    color: "black"
}
export const CompanyProfileIndustry = CompanyIndustry.extend `
  text-align: left;
  @media (max-width: 500px) {
    text-align: center;
  }
`

export const CompanyName = styled.h4 `
height: 50px;
  margin-top: 25px;
  color: #DAB777;
  text-align: center;
`
export const CompanyProfileName = CompanyName.extend `
  text-align: left;
  @media (max-width: 500px) {
    text-align: center;
  }
`

export const LabelWrapper = styled.div `
  margin: 25px;
`

export const CircleImage = styled.div `
  background: no-repeat url(${props => props.image});
  background-size:     contain;
  background-position: center center;
  margin: 0 auto;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  border-radius: ${props => props.size/2}px;

  @media (max-width: 500px) {
    margin-bottom: 15px;
  }
`
CircleImage.defaultProps = {
    size: 100,
    image: "https://res.cloudinary.com/theloge/image/upload/default_profile_image.jpg"
}

export const CompanyImage = styled.div `
background: no-repeat url(${props => props.image});
background-size:     contain;
background-position: center center;
margin: 0 auto;
height: ${props => props.size}px;
width: ${props => props.size}px;
`

export const CompanyImageNew = styled.div `
background: no-repeat url(${props => props.image});
background-size:     contain;
background-position: center center;
margin: 0 auto;
height: ${props => props.height}px;
width: ${props => props.width}px;
`

CircleImage.defaultProps = {
    size: 100,
    image: "https://res.cloudinary.com/theloge/image/upload/default_profile_image.jpg"
}


// WEBPACK FOOTER //
// /src/components/internal/MemberProfileStyle.js